import React, { useState } from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';
import { useAppSelector } from '@/store';
import { WebConfirmModal } from '@/components/common/modals/desktop/DesktopConfirmModal';
import { DesktopSectionHeader } from '@/components/residents/desktop/myAccount/DesktopSectionHeader';
import { useConfirmModal } from '@/hooks/common/useConfirmModal';
import { useSendVerificationEmailMutation } from '@/store/api';
import { useToast } from '@/contexts/admin/ToastContext';
import { strings, formatString } from '@/constants/residents/strings';

export const ResetPasswordView: React.FC = () => {
  const user = useAppSelector((s) => (s as any).auth?.user);
  const email = user?.email || '';
  const [sendVerificationEmail, { isLoading }] = useSendVerificationEmailMutation();
  const { visible: modalVisible, open: openModal, close: closeModal } = useConfirmModal(false);
  const { showSuccess, showError } = useToast();

  const handleReset = async () => {
    try {
      // Mirror web behavior: pass targetPath to route to success page
      await sendVerificationEmail({ email, targetPath: '/account/account-reset-password/success' }).unwrap();
      openModal();
      showSuccess('Verification email sent');
    } catch (_e) {
      // no-op; could add toast
      showError('Failed to send verification email');
    }
  };

  return (
    <View style={styles.root}>
      <DesktopSectionHeader
        title={strings.account.resetPasswordTitle}
        containerStyle={styles.header}
        titleStyle={styles.headerTitle}
      />
      <View style={styles.body}>
        <Text style={styles.copy}>{strings.account.resetPasswordCopy}</Text>
        <TouchableOpacity style={styles.btn} onPress={handleReset} disabled={isLoading}>
          <Text style={styles.btnText}>{isLoading ? 'Sending...' : strings.account.resetPasswordButton}</Text>
        </TouchableOpacity>
      </View>

      <WebConfirmModal
        visible={modalVisible}
        title={strings.account.resetPasswordModalTitle}
        message={formatString(strings.account.resetPasswordModalMessagePrefix, email)}
        confirmText={strings.account.resetPasswordModalResend}
        cancelText={strings.account.resetPasswordModalClose}
        onConfirm={handleReset}
        onCancel={closeModal}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  root: { flex: 1, backgroundColor: RESIDENTS_DESKTOP_COLORS.PRIMARY_BACKGROUND },
  header: { borderBottomWidth: 1, borderBottomColor: RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY, paddingHorizontal: 20, paddingVertical: 14 },
  headerTitle: { color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY, fontWeight: '700', fontSize: 18 },
  body: { padding: 24 },
  copy: { color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY, marginBottom: 16 },
  btn: { marginTop: 12, backgroundColor: RESIDENTS_DESKTOP_COLORS.BUTTON_PRIMARY, paddingVertical: 12, borderRadius: 10, alignItems: 'center' },
  btnText: { color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY, fontWeight: '700' },
});

export default ResetPasswordView;


